module.exports = __webpack_public_path__ + "fonts/FuturaPT-DemiObl.d80f52b1.woff2";